/**
 * Utilidades para formatear fechas en zona horaria de Ciudad de México (America/Mexico_City).
 */

const MEXICO_CITY_TZ = 'America/Mexico_City';

/**
 * Formatea una fecha en zona horaria de Ciudad de México (solo fecha).
 * @param date Fecha como Date o string ISO
 * @returns Ej: "9 de febrero de 2025"
 */
export function formatDateMexicoCity(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('es-MX', {
    timeZone: MEXICO_CITY_TZ,
    dateStyle: 'long',
  }).format(d);
}

/**
 * Formatea una fecha como DD/MM/YYYY.
 * @param date Fecha como Date o string ISO
 * @returns Ej: "09/02/2025"
 */
export function formatDateDDMMYYYY(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Formatea fecha y hora en zona horaria de Ciudad de México.
 * @param date Fecha como Date o string ISO
 * @returns Ej: "9 de febrero de 2025, 14:30:00"
 */
export function formatDateTimeMexicoCity(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('es-MX', {
    timeZone: MEXICO_CITY_TZ,
    dateStyle: 'long',
    timeStyle: 'medium',
  }).format(d);
}

/**
 * Devuelve la clave de fecha YYYY-MM-DD en zona horaria de Ciudad de México.
 * Útil para agrupar eventos por día local (CDMX).
 */
export function getDateKeyMexicoCity(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: MEXICO_CITY_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}
